import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_USER_REQUEST = 'appUser/FETCH_USER_REQUEST'
const FETCH_USER_SUCCESS = 'appUser/FETCH_USER_SUCCESS'
const FETCH_USER_FAILURE = 'appUser/FETCH_USER_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  userList: [],
}

// Default Reducer
const appUser = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        userList: action.payload
      }
    case FETCH_USER_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }

    default:
      return state
  }
}

export default appUser

// Action Creators
export const getAllAppUsers = (options) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_USER_REQUEST
      })

      const response = await API.get(EndPoints.APPUSER + `/search`, {
        params: options
      })
      dispatch({
        type: FETCH_USER_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_USER_FAILURE
      })
    }
  }
}










// WEBPACK FOOTER //
// ./src/modules/appUser.js